import { defineStore } from 'pinia'

// Utilities

export const useGeneralStore = defineStore('general', {
  state: () => ({
    accountDisplayCache: {
      filterManager: null,
      options: null
    },
    lastAccountIdNav: null
  }),

  getters: {
    hasCache: state =>
      !!state.accountDisplayCache.filterManager || !!state.accountDisplayCache.options,
    hasLastAccountIdNav: state => !!state.lastAccountIdNav
  },

  actions: {
    clearAccountDisplayCache() {
      this.accountDisplayCache = {
        filterManager: null,
        options: null
      }
    },

    setAccountDisplayCache(data) {
      let decoupledData = JSON.parse(JSON.stringify(data))
      this.accountDisplayCache = decoupledData
    },

    setLastAccountIdNav(target) {
      this.lastAccountIdNav = target
    }
  }
})
